
import * as PIXI from "pixi.js-legacy";
import { Tween, Ease } from "@createjs/tweenjs";

window.PIXI = PIXI;
window.Tween = Tween;
window.Ease = Ease;

window.PIXI.utils.skipHello();

export default {
  props: {
    frames: {
      type: Array,
      required: true,
    },
    autoAnimate: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 1600,
    },
    height: {
      type: Number,
      default: 900,
    },
  },
  data() {
    return {
      app: null,
      currentFrame: 0,
      dragging: null,
      lastX: 0,
      progress: 0,
      // sprites
      animatedProductSprite: null,
      hintSprite: null,
      placeholderImage: null,
    };
  },
  beforeDestroy() {
    if (this.animatedProductSprite) {
      this.animatedProductSprite.destroy();
    }

    if (this.pixiApp) {
      this.pixiApp.destroy();
    }
  },
  mounted() {
    if (process.browser) {
      this.init();
    }
  },
  methods: {
    init() {
      this.pixiApp = new window.PIXI.Application({
        width: this.width,
        height: this.height,
        antialias: true,
        transparent: true,
        resolution: 1,
      });

      if (this.pixiApp) {
        this.pixiApp.renderer.autoDensity = true;

        if (this.$refs.target) {
          this.$refs.target.appendChild(this.pixiApp.view);
        }

        this.createPlaceholderImage();

        this.pixiApp.loader.add(this.frames).load(() => {
          this.placeholderImage.destroy();
          this.createProductSprite();
        });

        this.pixiApp.loader.onProgress.add((a) => {
          this.progress = Math.round(a.progress);
        });
      }
    },

    createProductSprite() {
      const frames = this.frames.map((f) => window.PIXI.Texture.from(f));

      this.animatedProductSprite = new window.PIXI.AnimatedSprite(frames);
      this.animatedProductSprite.x = this.pixiApp.renderer.width / 2;
      this.animatedProductSprite.y = this.pixiApp.renderer.height / 2;
      this.animatedProductSprite.anchor.set(0.5);
      this.animatedProductSprite.loop = false;
      this.animatedProductSprite.animationSpeed = 0.35;
      this.animatedProductSprite.interactive = true;
      this.animatedProductSprite.buttonMode = false;
      this.pixiApp.stage.addChild(this.animatedProductSprite);

      this.animatedProductSprite.onComplete = () => this.init360();

      if (this.autoAnimate === true) {
        this.animatedProductSprite.gotoAndPlay(0);
      } else {
        this.init360();
      }
    },

    init360() {
      this.createHintSprite();
      if (this.frames.length > 1) {
        this.animatedProductSprite.cursor = "grab";
      }

      this.animatedProductSprite
        .on("pointerdown", this.onDragStart)
        .on("pointerup", this.onDragEnd)
        .on("pointerupoutside", this.onDragEnd)
        .on("pointermove", this.onDragMove);
    },

    createPlaceholderImage() {
      const img = new window.PIXI.Sprite(
        window.PIXI.Texture.from(this.frames[0])
      );
      img.x = this.pixiApp.renderer.width / 2;
      img.y = this.pixiApp.renderer.height / 2;
      img.anchor.set(0.5);
      img.interactive = false;
      img.buttonMode = false;

      this.placeholderImage = img;
      this.pixiApp.stage.addChild(this.placeholderImage);
    },

    createHintSprite() {
      if (this.frames.length > 1) {
        const texture = window.PIXI.Texture.from(
          require("assets/svg/heroicons/hand.svg")
        );

        const hintSprite = new window.PIXI.Sprite(texture);
        const hintSize = 200;
        const origin = this.pixiApp.renderer.width / 2 - hintSize / 2;
        hintSprite.interactive = false;
        hintSprite.height = hintSize;
        hintSprite.width = hintSize;
        hintSprite.loop = false;
        hintSprite.anchor.set(0.5);
        hintSprite.x = origin;
        hintSprite.y = this.pixiApp.renderer.height / 2;
        this.hintSprite = hintSprite;

        this.pixiApp.stage.addChild(this.hintSprite);

        window.Tween.get(this.hintSprite, { loop: 2 })
          .to({ x: origin + 200 }, 800, window.Ease.getPowInOut(2))
          .to({ x: origin }, 600, window.Ease.getPowInOut(2))
          .on("complete", () => {
            window.Tween.get(this.hintSprite).to({ alpha: 0 }, 200);
          });
      }
    },

    onDragStart(event) {
      if (this.hintSprite) {
        this.hintSprite.visible = false;
      }
      this.dragging = event.data;
    },

    onDragMove(event) {
      if (this.frames.length > 1) {
        if (this.dragging) {
          this.animatedProductSprite.cursor = "grabbing";

          const position = this.dragging.getLocalPosition(
            this.animatedProductSprite
          );
          const deltaX = position.x - this.lastX;
          const absoluteDx = Math.abs(deltaX);
          const speed = 5;

          if (absoluteDx > speed) {
            this.currentFrame += (deltaX * 1) / absoluteDx;

            if (this.currentFrame < 0) {
              this.currentFrame = this.frames.length - 1;
            } else if (this.currentFrame > this.frames.length - 1) {
              this.currentFrame = 0;
            }
            this.animatedProductSprite.gotoAndStop(this.currentFrame);
            this.lastX = position.x;
          }
        }
      }
    },

    onDragEnd() {
      if (this.frames.length > 1) {
        this.dragging = null;
        this.animatedProductSprite.cursor = "grab";
      }
    },
  },
};
